export default __webpack_public_path__ + "0b92b4b5cd7794250f6d051c9b266d22.svg";